import React, { useEffect } from 'react'

const About = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            <div className="">
                <div className="d-flex flex-wrap pt-5">

                    <div className="col-lg-6 ps-3">
                        <div className="resort-content">
                            <div className="resort-text">
                                <div className='about-icon mb-5'>
                                    <img src="/assets_web/img/about-us/about-us-icons.png" alt="HFHU-icons" />
                                </div>
                                <div>
                                    <h2 className="clrblu">
                                        <b>About HFHU</b>
                                    </h2>
                                    <p className='text-font pe-2'>
                                        'HFHU'-"Harmain Falah Hajj Umrah" is recognized as the world's
                                        number one event for facilitating Hajj and Umrah pilgrimages. Organized by A Hafiz and supported by Dhulia's most trusted
                                        Hajj and Umrah travel agencies, the campaign aims to assist a
                                        greater number of individuals in fulfilling this essential religious obligation. It has seen notable growth and achievements,
                                        including ongoing discussions with Afzal Sayyed of SAUDI
                                        TOURISM AUTHORITY, and collaborations with leading airlines,
                                        transport providers, and hoteliers. <br /> <br /> Efforts are also being made to expand collaborations with trusted travel agencies and explore potential agreements with GTC FX or other reliable FOREX providers to further enhance the campaign's reach and impact and more.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="urdu-section pe-3">
                            <p className='font-size-26'>
                                نبی کریم صلی اللہ علیہ وسلم نے فرمایا:<br />"حج اور عمرہ لگا تار کرنا : کیونکہ یہ غربت اور گناہ کو ایسے لگاتار دور کرتے ہیں جیسے بھٹی لوہے، سونے اور چاندی کی میل کو دور کرتی ہے۔" ۔ (سنن الترندی 810)
                            </p>
                        </div>
                        {/* <div className='mdn_img'> */}
                        <div className='w-100 d-none d-lg-block'>
                            <img src="/assets_web/img/about-us/madeena.png" alt="madeena (image)" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default About
